import { render, staticRenderFns } from "./MaterialButton.vue?vue&type=template&id=0abd7786&scoped=true"
import script from "./MaterialButton.vue?vue&type=script&lang=ts"
export * from "./MaterialButton.vue?vue&type=script&lang=ts"
import style0 from "./MaterialButton.vue?vue&type=style&index=0&id=0abd7786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd7786",
  null
  
)

export default component.exports